export default "__VITE_ASSET__0501cc06__"